var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-image",on:{"click":_vm.toDialogue}},[_c('img',{attrs:{"src":require("@/assets/images/home_head.png"),"alt":"首页图"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }